<template>
  <div class="v-main-wrapper">
    <v-header />
    <div v-if="loading" class="container pt-5">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <div v-else class="container">
      <div v-if="userData.role === 'administrator' ||
        userData.role === 'dealer' ||
        userData.role === 'employee'" class="row pt-md-5">
        <div class="col-lg-3">
          <v-main-menu :user-role="userData.role" />
        </div>
        <div class="col-lg-9">
          <router-view></router-view>
        </div>
      </div>

      <div v-else-if="userData.role === 'subscriber' && (!userData.passport )">
        <div class="text-center pb-5 text-danger font-weight-bold">
          <h4>Вам необходимо заполнить данные для договора!</h4>
        </div>
        <v-subscriber-update />
      </div>

      <router-view v-else></router-view>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VHeader from './layouts/v-header.vue';
import VMainMenu from './v-main-menu.vue';
import VSubscriberUpdate from './forms/v-subscriber-update.vue';

export default {
  name: 'v-main-wrapper',
  data() {
    return {
      loading: true,
    };
  },
  components: { VSubscriberUpdate, VMainMenu, VHeader },
  computed: {
    ...mapState('user', ['userData', 'error']),
  },
  methods: {
    ...mapActions('user', ['getUserDetail']),
  },
  mounted() {
    if (this.$route.path === '/login' || this.$route.path === '/checkout'
      || this.$route.path === '/password-reset') {
      this.loading = false;
    } else {
      this.getUserDetail()
        .finally(() => { this.loading = false; });
    }
  },
};
</script>
